<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route(to, from) {
      // document.body.scrollTop=document.documentElement.scrollTop=0
      if (to.path == "/") {
        window.document.documentElement.setAttribute("data-theme", "black");
      } else {
        window.document.documentElement.setAttribute("data-theme", "white");
      }
      
    },
  },
 
  mounted(){
    if (this.$route.path == "/") {
        window.document.documentElement.setAttribute("data-theme", "black");
      } else {
        window.document.documentElement.setAttribute("data-theme", "white");
      }
    this.$cookies.config('365d')
  }
};
</script>

<style>
.el-select-dropdown__item.selected{
  color: #fe4365 !important;
}
.el-select .el-input.is-focus .el-input__inner{
  border-color: #fe4365 !important;
}
 .el-select .el-input__inner:focus{
  border-color: #fe4365 !important;
}
.el-input.is-active .el-input__inner,
.el-textarea__inner:focus,
.el-input__inner:focus {
  border-color: #fe4365 !important;
}
.el-message-box .el-button--primary{
  border-color: #fe4365 !important;
  background: #fe4365 !important;
}
.el-message-box .el-button--primary:hover{
  border-color: #fe4365 !important;
  background: #fe4365 !important;
  color: #fff !important;
}
.el-message-box .el-button--small:hover{
  color: #fe4365 !important;
}
.el-button--danger {
  background: #fe4365 !important;
  border-color: #fe4365 !important;
}
.el-button--danger:hover {
  background: #fe4365 !important;
  border-color: #fe4365 !important;
}
.el-main,
.el-footer,
.el-header {
  padding: 0 !important;
}
#app,
html,
body {
  width: 100%;
  height: 100%;
}

* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
ul,
li {
  list-style-type: none;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
legend,
button form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue